import { capaTemplate } from './slides/capa'
import { fotoFullBleedTemplate } from './slides/foto-full-bleed'
import { fotoLegendaTemplate } from './slides/foto-legenda'
import { letraCapitularTemplate } from './slides/letra-capitular'
import { citacaoTemplate } from './slides/citacao'
import { aprendizadoTemplate } from './slides/aprendizado'
import { splitCtaTemplate } from './slides/split-cta'
import { tituloBlocosTemplate } from './slides/titulo-blocos'
import { capitularFotoTemplate } from './slides/capitular-foto'
import type { TemplateDefinition } from './types'

// Registro dos templates disponíveis no seletor do Criador de Mídias.
// Ordem aqui = ordem no seletor, e também a ordem "natural" de uma entrevista
// completa (ver DOCS/00-visao-geral.md a 06-split-cta.md, raiz do projeto
// "Lorena Magazine"), embora o usuário possa escolher em qualquer ordem.
export const TEMPLATE_REGISTRY: Record<string, TemplateDefinition> = {
  [capaTemplate.id]: capaTemplate,
  [fotoFullBleedTemplate.id]: fotoFullBleedTemplate,
  [fotoLegendaTemplate.id]: fotoLegendaTemplate,
  [letraCapitularTemplate.id]: letraCapitularTemplate,
  [citacaoTemplate.id]: citacaoTemplate,
  [aprendizadoTemplate.id]: aprendizadoTemplate,
  [tituloBlocosTemplate.id]: tituloBlocosTemplate,
  [capitularFotoTemplate.id]: capitularFotoTemplate,
  [splitCtaTemplate.id]: splitCtaTemplate,
}

export const TEMPLATE_LIST: TemplateDefinition[] = Object.values(TEMPLATE_REGISTRY)

export function getTemplate(id: string): TemplateDefinition | undefined {
  return TEMPLATE_REGISTRY[id]
}
